<template>
  <div class="chat">
    <h1>{{ $t('teamTaskDetail.sendMessage') }}</h1>
    <div class="chat-container">
      <b-overlay :show="blurLoading" variant="transparent" :opacity="1">
        <CommentContainer @needUpdate="loadMoreComment" :comments="comments" :goUp="goUp" />
        <form @submit.prevent="onSubmit" class="my-3">
          <input required :placeholder="$t('teamTaskDetail.comment')" v-model="message" />
          <button type="submit">{{ $t('teamTaskDetail.sendComment') }}</button>
        </form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import commentDataProvider from '../../services/comment'
import { commentMixins } from '../../utils/mixins'
import CommentContainer from './CommentContainer'
export default {
  name: 'comment',
  mixins: [commentMixins],
  components: { CommentContainer },
  props: {
    totalPages: {
      type: Number,
    },
  },
  data() {
    return {
      message: null,
      commentType: 3,
      connection: null,
      objectId: 0,
      blurLoading: false,
      commentLoading: false,
      commentPageData: {
        totalCount: null,
        pageNumber: 1,
      },
      goUp: false,
    }
  },
  beforeMount() {
    this.getComments(false, {
      commentType: this.commentType,
      pageNumber: 1,
      pageSize: 10,
      objectId: this.$route.params.id,
    })
  },
  computed: {
    apiPath() {
      if (this.$route.params.courseId) {
        return 'CourseComment'
      }
      if (this.$route.params.packageId) {
        return 'PackageComment'
      }
      return 'Comment'
    },
  },
  methods: {
    onSubmit() {
      this.sendComment()
    },
    sendComment() {
      this.blurLoading = true
      if (this.message !== null && this.message.length > 0) {
        commentDataProvider
          .postComment(
            {
              content: this.message,
              commentType: this.commentType,
              objectId: this.$route.params.id,
            },
            this.apiPath,
          )
          .then((res) => {
            setTimeout(() => {
              this.getComments(true, {
                commentType: this.commentType,
                pageNumber: 1,
                objectId: this.$route.params.id,
              })
              this.goUp = true
              this.$emit('updateWorkFlowHistory', true)
            }, 300)
          })
          .catch((error) => {})
      }
      this.message = ''
    },
    sendPackageComment() {
      this.blurLoading = true
      if (this.message !== null && this.message.length > 0) {
        commentDataProvider
          .postPackageComment(
            {
              content: this.message,
              commentType: this.commentType,
              objectId: this.$route.params.id,
            },
            this.apiPath,
          )
          .then((res) => {
            setTimeout(() => {
              this.getComments(true, {
                commentType: this.commentType,
                pageNumber: 1,
                objectId: this.$route.params.id,
              })
              this.goUp = true
              this.$emit('updateWorkFlowHistory', true)
            }, 300)
          })
          .catch((error) => {})
      }
      this.message = ''
    },
    getComments(addComment, data) {
      this.goUp = false
      commentDataProvider
        .getComment(data, this.apiPath + '/')
        .then((res) => {
          this.commentPageData.totalCount = res.data.pagination.totalCount
          const response = res.data.data
          if (addComment) {
            this.$store.dispatch('comment/addComment', response[0])
          } else {
            response.forEach((e) => this.$store.dispatch('comment/setComments', e))
          }
          this.blurLoading = false
          this.commentLoading = false
        })
        .catch((error) => {})
    },

    getPackageComments(addComment, data) {
      this.goUp = false
      commentDataProvider
        .getPackageComment(data, this.apiPath + '/')
        .then((res) => {
          this.commentPageData.totalCount = res.data.pagination.totalCount
          const response = res.data.data
          if (addComment) {
            this.$store.dispatch('comment/addComment', response[0])
          } else {
            response.forEach((e) => this.$store.dispatch('comment/setComments', e))
          }
          this.blurLoading = false
          this.commentLoading = false
        })
        .catch((error) => {})
    },
    loadMoreComment() {
      if (this.comments.length < this.commentPageData.totalCount) {
        this.commentPageData.pageNumber += 1
        this.getComments(false, { commentType: 3, objectId: this.$route.params.id, pageNumber: this.commentPageData.pageNumber })
      }
    },
  },
  watch: {},
  beforeDestroy() {
    this.$store.dispatch('comment/flushComments')
  },
}
</script>

<style scoped lang="scss">
@import '../../design/globalCss.scss';
h1 {
  font-family: IRANSans-bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  color: $dark-color;
  margin-bottom: 16px;
}
.chat {
  background-color: white;
  min-width: 100%;
  padding: 16px;
}
.chat-container {
  width: 100%;
  // position: relative;
}
form {
  display: flex;
  align-items: center;
}
button {
  background: #556be6;
  border-radius: 100px;
  color: white;
  padding: 8px 16px;
  margin-right: 10px;
}
input {
  width: 100%;
  padding: 8px;
  border: none;
  outline: none;
  background: #fafafa;
  border-radius: 100px;
  flex: 2;
}
</style>
